import type { ProgressStatus } from '../types';
import { PROGRESS_BADGE_CLASS } from '../types';

interface Props {
  status: ProgressStatus;
  small?: boolean;
}

export default function StatusBadge({ status, small }: Props) {
  const cls = PROGRESS_BADGE_CLASS[status] ?? 'badge-todo';
  const short: Record<ProgressStatus, string> = {
    'To Do':                       'To Do',
    'In Progress / Active Editing':'In Progress',
    'In Review':                   'In Review',
    'Handling Approved':           'Approved',
    'Pushed':                      'Pushed',
    'Merged into Live':            'Merged',
  };
  return (
    <span
      className={`inline-block font-heading uppercase tracking-wide pill ${cls} ${
        small ? 'text-[10px] px-1.5 py-0.5' : 'text-xs px-2 py-0.5'
      }`}
    >
      {small ? short[status] : status}
    </span>
  );
}
